import { Button } from '@design-system';
import { useTranslation } from 'next-i18next';
import { FC } from 'react';

import { useDrawButtonLabels } from '../../features/draws/hooks/useDrawButtonLabels';
import { DrawByProductId } from '../../features/draws/types';
import { useIsPreOrder } from '../../hooks/useIsPreOrder';
import { useAuth } from '../../providers';
import { useStore } from '../../store/utils';

interface Props {
  draw: DrawByProductId;
  isMobile: boolean;
  onClick: (isPreOrder: boolean) => void;
}

export const DrawStickyButtons: FC<Props> = ({ draw, isMobile, onClick }) => {
  const { isLoggedIn } = useAuth();
  const { t } = useTranslation('product');

  const drawEntry = useStore((s) => s.features.draw.drawEntry[draw.id]);
  const isPreOrder = useIsPreOrder(draw);
  const labels = useDrawButtonLabels('stickyCta', isPreOrder, isMobile);

  const entered = Boolean(drawEntry?.entered || draw.accountIsInDraw);
  const active = isLoggedIn && entered;

  return (
    <Button
      icon={active ? 'ic_check' : undefined}
      label={t(active ? labels.success : labels.normal)}
      onClick={() => onClick(isPreOrder)}
      size={isMobile ? 'sm' : 'md'}
      variant={active ? 'positive' : 'primary'}
    />
  );
};
